import { FunctionComponent, HTMLAttributes } from 'react';

const ViewMobile: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.769231 0.5H15.2308C15.3795 0.5 15.5 0.620539 15.5 0.769231V15.2308C15.5 15.3795 15.3795 15.5 15.2308 15.5H0.769231C0.620539 15.5 0.5 15.3795 0.5 15.2308V0.769231C0.5 0.620539 0.620539 0.5 0.769231 0.5Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <mask id="path-2-inside-1_1336_31576" fill="white">
      <path d="M7.5 1H8.5V15H7.5V1Z" />
    </mask>
    <path d="M7.5 1H8.5V15H7.5V1Z" fill="currentColor" />
    <path
      d="M7.5 1V0H6.5V1H7.5ZM8.5 1H9.5V0H8.5V1ZM8.5 15V16H9.5V15H8.5ZM7.5 15H6.5V16H7.5V15ZM7.5 2H8.5V0H7.5V2ZM7.5 1V15H9.5V1H7.5ZM8.5 14H7.5V16H8.5V14ZM8.5 15V1H6.5V15H8.5Z"
      fill="currentColor"
      mask="url(#path-2-inside-1_1336_31576)"
    />
    <mask id="path-4-inside-2_1336_31576" fill="white">
      <path d="M15 7.5L15 8.5L1 8.5L1 7.5L15 7.5Z" />
    </mask>
    <path d="M15 7.5L15 8.5L1 8.5L1 7.5L15 7.5Z" fill="currentColor" />
    <path
      d="M15 7.5L16 7.5L16 6.5L15 6.5L15 7.5ZM15 8.5L15 9.5L16 9.5L16 8.5L15 8.5ZM1 8.5L-4.37114e-08 8.5L-8.74228e-08 9.5L1 9.5L1 8.5ZM1 7.5L1 6.5L4.37114e-08 6.5L0 7.5L1 7.5ZM14 7.5L14 8.5L16 8.5L16 7.5L14 7.5ZM15 7.5L1 7.5L1 9.5L15 9.5L15 7.5ZM2 8.5L2 7.5L0 7.5L-4.37114e-08 8.5L2 8.5ZM1 8.5L15 8.5L15 6.5L1 6.5L1 8.5Z"
      fill="currentColor"
      mask="url(#path-4-inside-2_1336_31576)"
    />
  </svg>
);

export default ViewMobile;
